import React from 'react';

const FormInput = ({ tag, type, name, placeholder, classes }) => {
    return (
        <div className="single-input-item">
            <label>
                {(() => {
                    if (tag === 'input') {
                        return <input type={type} name={name} placeholder={placeholder} className={classes} />;
                    } else if (tag === 'textarea') {
                        return <textarea name={name} cols="30" rows="7" placeholder={placeholder} className={classes} required />;
                    } else if (tag === 'button') {
                        return (
                            <button
                                style={{
                                    border: '2px solid grey', // Default border is grey
                                    borderRadius: '100px',
                                    color: '#151515',
                                    display: 'inline-block',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    lineHeight: '1',
                                    padding: '18px 55px',
                                    backgroundColor: 'transparent',
                                    cursor: 'pointer',
                                    transition: '0.4s',
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = 'grey';
                                    e.target.style.color = 'white';
                                    e.target.style.borderColor = 'grey';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.color = '#151515';
                                    e.target.style.borderColor = 'grey'; // Revert to grey border
                                }}
                            >
                                Send Message
                            </button>
                        );
                    }
                })()}
            </label>
        </div>
    );
};

export default FormInput;
